import { render, staticRenderFns } from "./singleCustomer.vue?vue&type=template&id=44547b2d&scoped=true&"
import script from "./singleCustomer.vue?vue&type=script&lang=js&"
export * from "./singleCustomer.vue?vue&type=script&lang=js&"
import style0 from "./singleCustomer.vue?vue&type=style&index=0&id=44547b2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44547b2d",
  null
  
)

export default component.exports